import React from 'react';
import '../../../assets/styles/customer/components/MyButton.css';

const MyButton = ({ 
  children, 
  variant = 'primary', 
  onClick, 
  type = 'button',
  className = '',
  ...props 
}) => {
  return (
    <button 
      className={`custom-btn custom-btn-${variant} ${className}`}
      onClick={onClick}
      type={type}
      {...props}
    >
      {children}
    </button>
  );
};

export default MyButton;